import RtwProductType from "./actionTypes"



// function that called as action
const getListPage = data => ({
  type: RtwProductType.GET_RTW_PRODUCT_PAGES,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListPageSuccess = data => ({
  type: RtwProductType.GET_RTW_PRODUCT_PAGES_SUCCESS,
  payload: data,
})

// function that called as action
const getDetail = (data, action) => ({
  type: RtwProductType.GET_DETAIL_RTW_PRODUCT_BY_ID,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const getDetailSuccess = data => ({
  type: RtwProductType.GET_DETAIL_RTW_PRODUCT_BY_ID_SUCCESS,
  payload: data,
})

// function that called as action
const postData = (data, action) => ({
  type: RtwProductType.POST_RTW_PRODUCT,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const postDataSuccess = data => ({
  type: RtwProductType.POST_RTW_PRODUCT_SUCCESS,
  payload: data,
})

// function that called as action
const putData = (data, action) => {
  return {
    type: RtwProductType.PUT_RTW_PRODUCT,
    payload: data,
    action
  }
}

// function to update state in reducer when fetching api is succeed or failed
const putDataSuccess = data => ({
  type: RtwProductType.PUT_RTW_PRODUCT_SUCCESS,
  payload: data,
})


const RtwProductAction = {
  getListPage,
  getListPageSuccess,


  getDetail,
  getDetailSuccess,


  postData,
  postDataSuccess,

  putData,
  putDataSuccess,

}

export default RtwProductAction





